import "./preloadPolyfills"
import "legacyBs5"
import "reactLoader"

import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import SessionExpiryAlertBootstrap from "SessionExpiry/AlertBootstrap"

console.log("applicationBs5")
const root = document.querySelector("#sessionExpiry")
if (root) {
  createRoot(root).render(
    <StrictMode>
      <SessionExpiryAlertBootstrap userId={window.currentUserId} />
    </StrictMode>
  )
}